// extracted by mini-css-extract-plugin
module.exports = {"boton":"paginado_boton__3IJc2","container":"paginado_container__3AyfO","active":"paginado_active__PYci3"};